<div class="logo-container" (click)="backToHome()">
    <img class="logo" src="../../../assets/logo.png" alt="logo-policlinico">
</div>